import React, { useState } from "react";
import OTP from "./OTP";
import { Button, Form, Input, message } from "antd";
import { IoIosSend } from "react-icons/io";
import { IoMdMail } from "react-icons/io";
import { IoSend } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import axios from "axios";
import { API_BASE_URL } from "../../services/apiConfig";
// import { post } from "../../apiService";

export default function EmailEnter({ setOtpSubmit, setUserEmail, setOtpData }) {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpSend, setOtpSend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendAfter, setResendAfter] = useState(60);
  const [form] = Form.useForm();
  const handleOtpSend = async () => {
    try {
      setLoading(true);
      const value = form.getFieldsValue();
      setUserEmail(value.email);

      const resp = await axios.post(`${API_BASE_URL}users/forgot-password/send-otp`, {
        email: value.email,
      });

      if (resp.data?.success) {
        message.success(resp.data.message || "OTP sent successfully");
        setOtpSend(true);
        const resendSeconds = Number(resp.data.resend_after) || 60;
        setResendAfter(resendSeconds);
        return resendSeconds;
      } else {
        message.error(resp.data?.message || "Unable to send OTP");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Unable to send OTP");
      console.error(error);
    } finally {
      setLoading(false);
    }
    return 0;
  };

  const handleOtpSubmit = async () => {
      const otpValue = otp.join("");
      if (otpValue.length !== 6) {
        message.error("Please enter the 6-digit OTP");
        return;
      }

    try {
      setLoading(true);
      const value = form.getFieldsValue();
      const resp = await axios.post(`${API_BASE_URL}users/forgot-password/verify-otp`, {
        email: value.email,
        otp: otpValue,
      });

      if (resp.data?.success && resp.data?.reset_token) {
        setOtpData(resp.data.reset_token);
        setUserEmail(value.email);
        setOtpSubmit(true);
        message.success(resp.data.message || "OTP verified successfully");
      } else {
        message.error(resp.data?.message || "Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.message || "OTP invalid, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inputCard">
      <h4>Forgot Password</h4>
      <p>
        {otpSend
          ? "Step 2 of 3: Enter the OTP sent to your email."
          : "Step 1 of 3: Enter your email to receive a password reset OTP."}
      </p>
      <Form
        layout="vertical"
        onFinish={otpSend ? handleOtpSubmit : handleOtpSend}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
            },
            { type: "email" },
          ]}
        >
          <Input
            type="email"
            disabled={otpSend}
            prefix={<IoMdMail />}
            className="formInput"
            placeholder="Registred Email ID / Registred Number"
          />
        </Form.Item>
        {otpSend && (
          <OTP
            otp={otp}
            setOtp={setOtp}
            handleOtpSend={handleOtpSend}
            resendAfter={resendAfter}
          />
        )}
        <Form.Item>
          {otpSend ? (
            <Button
              htmlType="submit"
              className="addButtons bg-dark text-white"
              icon={<IoSend />}
              loading={loading}
            >
              Submit OTP
            </Button>
          ) : (
            <Button
              htmlType="submit"
              className="addButtons bg-dark text-white"
              icon={<IoIosSend />}
              loading={loading}
            >
              Send OTP
            </Button>
          )}
        </Form.Item>
      </Form>
      <NavLink to="/account/sign-in">
        <FaAngleLeft /> Back to login page
      </NavLink>
    </div>
  );
}
